import { testimonials } from '@/mocks/gossip';

export default function AboutSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="container-site grid grid-cols-1 lg:grid-cols-12 gap-8">
        {/* 关于 */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-1.5 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium tracking-widest text-foreground-500">ABOUT US</span>
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-snug">
              关于<span className="text-primary-600">吃瓜黑料</span>
            </h2>
            <p className="mt-4 text-foreground-600 leading-relaxed">
              我们是一群对娱乐热点保持着旺盛好奇心的整理者。在这个信息爆炸、真假难辨的吃瓜时代，与其被情绪裹挟，
              不如先把事件按时间线摆清楚。
            </p>
            <div className="mt-6 space-y-4">
              {[
                { icon: 'ri-time-line', title: '只做整理，不下结论', desc: '完整保留各方说法，把前因后果交给读者自己判断。' },
                { icon: 'ri-file-shield-line', title: '公开来源，接受勘误', desc: '尽量标注出处线索，发现错误第一时间修正并记录。' },
                { icon: 'ri-sparkling-line', title: '中立视角，拒绝站队', desc: '不制造对立、不贩卖焦虑，还原事件本身的样子。' },
              ].map((f) => (
                <div key={f.title} className="flex gap-4">
                  <span className="w-11 h-11 shrink-0 rounded-xl bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className={`${f.icon} text-xl`}></i>
                  </span>
                  <div>
                    <h3 className="font-semibold text-foreground-900">{f.title}</h3>
                    <p className="mt-1 text-sm text-foreground-600 leading-relaxed">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* 口碑 */}
        <div className="lg:col-span-7">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {testimonials.map((t) => (
              <figure key={t.name} className="rounded-2xl border border-background-200 bg-background-50 p-6 flex flex-col">
                <div className="flex items-center gap-1 text-accent-500">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i key={i} className={i < t.score ? 'ri-star-fill' : 'ri-star-line'}></i>
                  ))}
                </div>
                <blockquote className="mt-4 flex-1 text-sm text-foreground-700 leading-relaxed">“{t.text}”</blockquote>
                <figcaption className="mt-5 flex items-center gap-3 pt-4 border-t border-background-100">
                  <span className="w-10 h-10 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center font-semibold">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <div className="text-sm font-semibold text-foreground-900">{t.name}</div>
                    <div className="text-xs text-foreground-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}